import { type Edge } from "@atlaskit/pragmatic-drag-and-drop-hitbox/dist/types/types";
import { cnTwMerge } from "@vega-core/utils/cnTwMerge";

export function DropIndicator({ edge }: { edge: Edge }) {
  return (
    <div
      className={cnTwMerge(
        "absolute top-2 bottom-2 w-0.5 bg-text/pending",
        edge === "left" ? "left-[7px]" : "right-[7px]",
      )}
    />
  );
}
